import { Tr as ChakraTr } from '@chakra-ui/react';
import { forwardRef } from 'react';

export const Tr = forwardRef(({ onClick, children, ...rest }, ref) => (
  <ChakraTr onClick={onClick} {...rest} ref={ref}>
    {children}
  </ChakraTr>
));
